import React, { Fragment, useState } from 'react'
import { GenericTable } from '../../_EOS/Table'
import { State, Status } from '../../../hooks/useFetchState'
import { usePagination } from '../../../hooks/usePagination'
import { Box } from '@mui/material'
import { ApiResponse } from '../../../typings/ApiResponse'
import SlimSearchBar from '../../_WMS/SlimSearchBar/SlimSearchBar'
import { AsnDetailsReservedDto } from './api/dto'

interface AsnReservedDetailsProps {
  getReservedElements: (page: number, pageSize: number, sku: string) => void
  state: State<ApiResponse<AsnDetailsReservedDto>>
}

export const AsnReservedDetails: React.FC<AsnReservedDetailsProps> = ({
  state,
  getReservedElements
}) => {
  const [searchSku, setSearchSku] = useState('')

  const pagination = usePagination(5)

  const handlePaginationChange = (page: number, pageSize: number) => {
    // If the pageSize is different, we should set page 0
    const auxPage = pagination.pageSize !== pageSize ? 0 : page

    getReservedElements(auxPage, pageSize, searchSku)

    pagination.setPagination(auxPage, pageSize)
  }

  const handleResetSearch = () => {
    getReservedElements(0, 5, '')
    setSearchSku('')
  }

  const handleSKUSearch = () => {
    getReservedElements(pagination.page, pagination.pageSize, searchSku)
  }

  return (
    <Fragment>
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        width='100%'
      >
        <Box width='100%' maxWidth='400px'>
          <SlimSearchBar
            onResetSearch={handleResetSearch}
            buttonTitle='Buscar'
            onChangeTextField={setSearchSku}
            onSearch={handleSKUSearch}
            textFieldValue={searchSku}
          />
        </Box>
      </Box>
      <GenericTable<AsnDetailsReservedDto>
        headersConfig={[
          { field: 'sku', title: 'SKU', sortable: true },
          { field: 'reservedQty', title: 'Cantidad Reservada', sortable: true }
        ]}
        IDKey={'sku'}
        data={state.data?.items}
        isLoading={state.status === Status.Loading}
        pagination={{
          page: pagination.page,
          pageSize: pagination.pageSize,
          totalItem: state.data?.totalItems || 0
        }}
        onPaginationChange={handlePaginationChange}
      />
    </Fragment>
  )
}
